export const environment = {
  production: false,
API_URL: 'https://app.signing247.com/'
//API_URL: 'http://localhost:1884/'
//API_URL: 'http://13.126.56.238:8190/'

 //API_URL: 'http://devapi.signing247.com/'

};
////